import { useContext, useEffect, useRef, useState } from "react";
import { ReactComponent as ChatIcon } from "../../../../assets/img/icon/question_answer_black_24dp.svg";
import { client } from "../../../../services/mqttService/mqttService";
import { GlobalContext } from "../../../contexts/globalContext";
import PageTitle from "../../../ui/atoms/PageTitle/PageTitle";

const rootMessages = [
  {
    id: 1,
    text: "lorem ipsum",
    user: { id: 1, name: "Yudi Aditya", initial: "YA" },
  },
  {
    id: 2,
    text: "dolor sit amet",
    user: { id: 2, name: "Jane Doe", initial: "JD" },
  },
  {
    id: 3,
    text: "consectum ali",
    user: { id: 3, name: "Doctor Strange", initial: "DS" },
  },
];

const dataMessages = [
  [
    {
      id: 1,
      text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, explicabo! Explicabo quibusdam dolor obcaecati illum nostrum vel veritatis ratione blanditiis!",
      createdAt: "02:32",
      isSender: false,
    },
    {
      id: 2,
      text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit.",
      createdAt: "02:35",
      isSender: false,
    },
    {
      id: 3,
      text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, magnam exercitationem reiciendis mollitia illum vero.",
      createdAt: "02:44",
      isSender: true,
    },
    {
      id: 4,
      text: "Et, magnam exercitationem reiciendis mollitia illum vero.",
      createdAt: "02:50",
      isSender: true,
    },
    {
      id: 5,
      text: "Consectetur adipisicing elit.",
      createdAt: "02:59",
      isSender: false,
    },
    {
      id: 6,
      text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure error dolorum saepe adipisci quasi amet officia dignissimos vel tempora? Debitis asperiores dolores sed dolor blanditiis veniam unde itaque optio tenetur!",
      createdAt: "02:59",
      isSender: false,
    },
    {
      id: 7,
      text: "Iure error dolorum saepe adipisci quasi amet officia dignissimos vel tempora?",
      createdAt: "02:59",
      isSender: true,
    },
    {
      id: 8,
      text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias distinctio ad eaque dicta facere quas est possimus quia. Similique voluptate beatae non exercitationem quae nihil totam esse aut molestiae facilis!",
      createdAt: "02:59",
      isSender: true,
    },
  ],

  [
    {
      id: 1,
      text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias distinctio ad eaque dicta facere quas est possimus quia. Similique voluptate beatae non exercitationem quae nihil totam esse aut molestiae facilis!",
      createdAt: "02:32",
      isSender: true,
    },
    {
      id: 2,
      text: "Iure error dolorum saepe adipisci quasi amet officia dignissimos vel tempora?",
      createdAt: "02:35",
      isSender: false,
    },
    {
      id: 3,
      text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, magnam exercitationem reiciendis mollitia illum vero.",
      createdAt: "02:44",
      isSender: true,
    },
    {
      id: 4,
      text: "Et, magnam exercitationem reiciendis mollitia illum vero.",
      createdAt: "02:50",
      isSender: true,
    },
  ],

  [
    {
      id: 1,
      text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Et, magnam exercitationem reiciendis mollitia illum vero.",
      createdAt: "02:44",
      isSender: true,
    },
    {
      id: 2,
      text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias distinctio ad eaque dicta facere quas est possimus quia. Similique voluptate beatae non exercitationem quae nihil totam esse aut molestiae facilis!",
      createdAt: "02:32",
      isSender: true,
    },
    {
      id: 3,
      text: "Iure error dolorum saepe adipisci quasi amet officia dignissimos vel tempora?",
      createdAt: "02:35",
      isSender: false,
    },
  ],
];

const MessageList = () => {
  const isMounted = useRef(true);
  const [state, setState] = useState({
    message: "",
  });

  const [loading, setLoading] = useState(true);

  const [rootMessage, setRootMessage] = useState(rootMessages[0].user);
  const [messages, setMessages] = useState(dataMessages[0]);
  const [sharedState, dispatch] = useContext(GlobalContext);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && state.message !== "") {
      setMessages((prevState) => [
        ...prevState,
        {
          id: prevState.length,
          text: state.message,
          createdAt: "02:50",
          isSender: true,
        },
      ]);
      setState((prevState) => ({ ...prevState, message: "" }));
    }
  };

  useEffect(() => {
    return () => {
      client.unsubscribe(`+/state`);
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Percakapan"
          description="Gunakan fitur percakapan untuk berkirim pesan kepada kolega atau klien anda."
          icon={
            <ChatIcon className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />

        <div className="mt-12 md:mt-16">
          <div className="border border-primary rounded-lg shadow-lg overflow-hidden">
            <div className="flex">
              <div
                className="w-full md:w-64 overflow-y-auto divide-y divide-y-reverse"
                style={{ height: "32rem" }}
              >
                <div className="bg-primary w-full py-2.5 px-2 h-14 flex flex-col justify-center">
                  <input
                    type="text"
                    placeholder="cari percakapan"
                    className="bg-white bg-opacity-10 text-white border border-white border-opacity-0 placeholder-white placeholder-opacity-40 rounded-full w-full px-4 py-1 focus:outline-none focus:border-opacity-50 focus:bg-opacity-20"
                  />
                </div>

                {rootMessages.map((message, idx) => (
                  <div
                    key={"message" + idx}
                    className={
                      "py-2 px-2 cursor-pointer  " +
                      (message.user.id === rootMessage.id
                        ? "bg-gray-200"
                        : "bg-white hover:bg-gray-50")
                    }
                    onClick={() => {
                      setRootMessage(message.user);
                      setMessages(dataMessages[message.user.id - 1]);
                    }}
                  >
                    <div className="flex space-x-2.5 items-center ">
                      <div className="flex-shrink-0">
                        <div className="bg-primary tracking-wider font-medium text-white rounded-full w-8 h-8 flex flex-col justify-center items-center">
                          {message.user.initial}
                        </div>
                      </div>
                      <div className="flex-1 text-gray-800 ">
                        <div>{message.user.name}</div>
                        <div className="text-xs text-gray-800 text-opacity-70">
                          {message.text}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="hidden md:block w-full flex-1 border-l border-gray-300 relative">
                <div className=" bg-primary px-3 py-2.5 items-center space-x-2 h-14 flex">
                  <div className="flex-shrink-0">
                    <div className="bg-white tracking-wider font-medium text-primary rounded-full w-8 h-8 flex flex-col justify-center items-center">
                      {rootMessage.initial}
                    </div>
                  </div>
                  <div className="flex-1 text-white">
                    <div>{rootMessage.name}</div>
                  </div>
                </div>

                <div
                  className="flex flex-col px-3 pt-2.5 pb-20 relative overflow-y-auto"
                  style={{ height: "32rem" }}
                >
                  {messages.map((message) => (
                    <div
                      className={
                        "py-2 flex  " +
                        (message.isSender ? "justify-end" : "justify-start")
                      }
                    >
                      <div
                        className={
                          "cursor-pointer text-sm rounded-md px-2 py-1 max-w-md md:max-w-lg border border-gray-300 hover:bg-gray-200 " +
                          (message.isSender ? "bg-gray-100" : "bg-gray-50 ")
                        }
                      >
                        <div className="text-gray-800">{message.text}</div>
                        <div className="text-xs text-right text-gray-700 text-opacity-60 mt-1">
                          {message.createdAt}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gray-200 px-3 py-2.5 ">
                  <input
                    className="px-3 py-2 bg-white rounded-full w-full text-sm focus:outline-none"
                    placeholder="ketik pesan anda disini"
                    name="message"
                    value={state.message}
                    onChange={handleChange}
                    onKeyPress={handleKeyPress}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageList;
